import { render } from "./contactoView.vue?vue&type=template&id=e57bc142"
import script from "./contactoView.vue?vue&type=script&lang=js"
export * from "./contactoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__